module.exports = __webpack_public_path__ + "static/media/camera.811e4016.png";